import type { MutationTree } from 'vuex'
import type { DivisionState, SelectCompanyModel } from './types'
import {
  GET_ALL_DIVISION,
  GET_ALL_REGION,
  SCAN_ALL_DIVISION,
  SELECT_COMPANY,
  SELECTED_DIVISION,
  SET_CURRENT_PAGE,
  SET_SELECTED_ROWS,
} from './types'

export const mutations: MutationTree<DivisionState> = {
  [GET_ALL_DIVISION](state: DivisionState, data: DivisionModel[]) {
    state.divisions = data.map((item) => ({
      ...item,
      regionLabel: state.regions
        .filter((region) => item.region.includes(region.code))
        .map((i) => i.name)
        .join(', '),
    }))
  },
  [GET_ALL_REGION](state: DivisionState, data: DropDownItem[]) {
    state.regions = data
  },
  [SCAN_ALL_DIVISION](state: DivisionState, data: DivisionModel[]) {
    state.divisions = data
  },
  [SELECT_COMPANY](state: DivisionState, data: SelectCompanyModel) {
    localStorage.setItem('company', data.company as string)
    localStorage.setItem('region', data.region as string)
    state.selectCompany = data
  },
  [SELECTED_DIVISION](state: DivisionState, data: string) {
    state.selectedDivision = data
  },
  [SET_CURRENT_PAGE](state: DivisionState, numPage: number) {
    state.currentPage = numPage
  },
  [SET_SELECTED_ROWS](state: DivisionState, rows: number) {
    state.selectedRows = rows
  },
}
